<template>
  <!-- 横向排列 模式 type -> 1  =>  文字 -->
  <!-- 横向排列 模式 type -> 2  =>  图片2 (1-20) || 文字-->
  <div class="g_switch-1">
    <h3 class="tc-b" v-if="title">
      <span class="t_wei">{{title}}</span>
    </h3>
    <div class="g_switch-wrap">
      <v-switch-item1
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
    </div>
  </div>
</template>

<script>
// 横向-单行流式布局
import VSwitchItem1 from "../switch-item/g_switch-item1";
import Vue from "../../../utils/bus";
export default {
  name: "g_switch-1",
  components: {
    VSwitchItem1
  },
  props: {
    selectRule: {
      type: Function,
      default: () => true
    },
    chip: String,
    horizontalType: {
      type: Number,
      default: 1
      // 横向 1 -> 1 文字                  + rate               + select
      // 横向 2 -> 3 数字(1-20) || 文字     + rate               + select
      // 横向 3 -> 5 数字(1-20)                                 + select
    },
    columns: {
      type: Number,
      default: 5
    },
    title: {
      type: String,
      default: "title"
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isSelectAll: false,
      key:0
    };
  },
  created() {
    Vue.$on("changSelect", (item) => {
       if(item == this.title||item=="all"){
         if(this.isSelectAll){
           this.isSelectAll=false;
           //Vue.$emit("resetInput");
         }else {
           this.isSelectAll=true;
         }
      }
    });
    Vue.$on("reset",()=>{
      this.isSelectAll=false;
    });
     Vue.$on("resetDefault",()=>{
      this.isSelectAll=false;
    })
  },
  computed: {
    type() {
      // 将列表项 映射 成正确的item 1 -> 1、2 -> 3
      let _type = 1;
      switch (this.horizontalType) {
        case 1:
          _type = 1;
          break;
        case 2:
          _type = 3;
          break;
        case 3:
          _type = 5;
          break;
      }
      return _type;
    }
  }
};
</script>

<style scoped lang="stylus">
$border-color = #E6E6E6;

.g_switch-1 {
  h3 {
    width: 100%;
    height: 26px;
    border: 1px solid $border-color;
    position: relative;
    font-size: 13px;
    box-sizing: border-box;
    text-align: center;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 2px;
    background: linear-gradient(#FEFEFE, #F0F0F0);

    span {
      display: inline-block;
      position: relative;

      &:before, &:after {
        top: 50%;
        display: block;
        content: '';
        height: 1px;
        position: absolute;
      }

      &:before {
        left: -45px;
      }

      &:after {
        right: -45px;
      }
    }
  }

  .g_switch-wrap {
    font-size: 13px;
    position: relative;
    overflow: hidden;
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;

    &:after {
      left: 0;
      width: 100%;
      height: 1px;
      bottom: 0;
      content: '';
      display: block;
      position: absolute;
      background-color: $border-color;
    }

    .switch-1 {
      float: left;
      box-sizing: border-box;
      border-left: 1px solid $border-color;
    }

    .switch-1:last-child {
      box-sizing: border-box;
      border-right: 1px solid $border-color;
    }

    .w-4 {
      width: 25%;
    }

    .w-5 {
      width: 20%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-list/g_switch-1.vue